<template>
  <v-bottom-sheet 
    v-model="open" 
    max-width="500px" 
    lazy 
    inset 
    persistent>
    <v-toolbar color="secondary">
      <v-toolbar-title class="primarytext--text">Modifica nota spesa {{ notaCategoria }}</v-toolbar-title>
      <v-spacer/>
      <v-btn 
        icon 
        @click="open = false">
        <v-icon color="white">close</v-icon>
      </v-btn>
    </v-toolbar>
    <v-card v-if="notaItem">
      <v-layout 
        row 
        wrap 
        style="padding: 10px">
        <v-flex 
          v-if="nota.isAuto == false" 
          xs4 
          style="margin-right: 50px">
          <v-text-field
            :value="notaItem.importo"
            v-model="importo"
            type="number"
            color="tree"
            label="Importo"
            required
            @blur="verifyImporto"
          />
        </v-flex>
        <v-flex xs1>
          <v-btn
            flat
            icon
            label="Ricevuta"
            color="tree"
            @click.stop="open_modal(notaItem)"
          >
            <v-tooltip left>
              <v-icon slot="activator">fas fa-file-invoice</v-icon>
              <span>Clica per mostrare</span>
            </v-tooltip>
          </v-btn>
          <ImagePdfPreview
            v-if="img"
            :src="imgPath"
            :name="img"
            :show="dialog"
            @on-click-close="closeImgPrewHandler"
          />
        </v-flex>
        <v-flex xs4>
          <input
            ref="libretto"
            type="file"
            style="display: none"
            accept="image/*, application/pdf"
            @change="onFilePickedRicevuta"
          >
          <v-btn 
            v-if="!ricevutaFile" 
            flat 
            @click="pickFileRicevuta">
            <v-icon 
              color="tree" 
              left>attach_file</v-icon>Cambia ricevuta
          </v-btn>
          <v-chip 
            v-else 
            outline 
            color="tree">
            <v-icon 
              left 
              style="padding: 0 10px;">fas fa-receipt</v-icon>
            <v-tooltip 
              right 
              color="white" 
              style="opacity: 1;" 
              z-index="300">
              <span slot="activator">{{ ricevutaName }}</span>
              <span>
                <img 
                  v-if="ricevutaName.split('.').pop() !== 'pdf'" 
                  :src="ricevutaUrl" 
                  width="250">
                <embed 
                  v-else 
                  :src="ricevutaUrl" 
                  width="500" 
                  height="375" 
                  type="application/pdf">
              </span>
            </v-tooltip>
            <v-icon
              v-if="ricevutaFile"
              style="padding: 0 5px;"
              right
              small
              color="error"
              @click.stop="onFileDettach"
            >fas fa-trash-alt</v-icon>
          </v-chip>
        </v-flex>
      </v-layout>
      <v-card-actions v-if="checkMotivazione">
        <v-flex>
          <span>
            <b>Motivazione:</b>
            {{ notaItem.motivo_no_conferma }}
          </span>
        </v-flex>
      </v-card-actions>
      <v-card-actions>
        <v-spacer/>
        <v-btn 
          color="tree" 
          class="primary--text" 
          @click="modificaNota(importo, nota.isAuto !== false)">
          <v-icon 
            small 
            left 
            color="primary">save</v-icon>Aggiorna
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-bottom-sheet>
</template>

<script>
import ImagePdfPreview from "./ImagePdfPreview.vue";
export default {
  name: "CambiaNota",
  components: {ImagePdfPreview},
  props: {
    nota: {
      type: Object,
      required: true
    },
    modNota: {
      type: Boolean,
      required: true
    },
    mese: {
      type: String,
      required: true
    },
    idRichiesta: {
      type: String,
      required: true
    }
  },
  data: () => ({
    open: false,
    dialog: false,
    importo: null,
    ricevutaName: null,
    ricevutaFile: null,
    ricevutaUrl: null
  }),
  computed: {
    checkMotivazione () {
      return Boolean(this.notaItem.motivo_no_conferma)
    },
    notaItem () {
        return this.nota.dettaglio
    },
    notaCategoria () {
        return this.notaItem.descrizione
    },
    maxImporto () {
        return +this.notaItem.max_importo
    },
    img () {
        return this.nota.isAuto ? this.notaItem.img_libretto : this.notaItem.img
    },
    imgPath () {
        return this.$store.getters.getPageData.imgsPath + ( this.nota.isAuto ? 'libretti/' : 'scontrini/') + this.img
    },
    isPDF () {
        return this.img.split('.').pop() === 'pdf'
    }
  },
  watch: {
    modNota(val) {
      this.open = val;
    },
    open(val) {
      if (!val) this.$emit("onClose");
      else this.importo = this.notaItem.importo;
    }
  },
  methods: {
    closeImgPrewHandler() {
      console.log('CLOSE');
      
      this.dialog = false;
    },
    open_modal(item) {
      this.dialog = true;
    },
    onFilePicked(e, indiceSpesa) {
      const files = e.target.files;
      if (files[0] !== undefined) {
        this.ricevutaName = files[0].name;
        if (this.ricevutaName.lastIndexOf(".") <= 0) {
          return;
        }
        const fr = new FileReader();
        fr.readAsDataURL(files[0]);
        fr.addEventListener("load", () => {
          this.ricevutaUrl = fr.result;
          this.ricevutaFile = files[0];
        });
      } else {
        this.ricevutaName = "";
        this.ricevutaFile = "";
        this.ricevutaUrl = "";
      }
    },
    onFilePickedRicevuta(e, indiceSpesa) {
      const files = e.target.files;
      if (files[0] !== undefined) {
        this.ricevutaName = files[0].name;
        if (this.ricevutaName.lastIndexOf(".") <= 0) {
          return;
        }
        const fr = new FileReader();
        fr.readAsDataURL(files[0]);
        fr.addEventListener("load", () => {
          this.ricevutaUrl = fr.result;
          this.ricevutaFile = files[0];
        });
      } else {
        this.ricevutaName = "";
        this.ricevutaFile = "";
        this.ricevutaUrl = "";
      }
    },
    pickFile(indice) {
      this.$refs["image" + indice][0].click();
    },
    pickFileRicevuta() {
      this.$refs.libretto.click();
    },
    onFileDettach() {
      // this.$refs.libretto.value = null;
      this.ricevutaName = "";
      this.ricevutaFile = "";
      this.ricevutaUrl = "";
    },
    verifyImporto() {
        if (this.maxImporto > 0 && this.importo > this.maxImporto) {
            this.$swal({
                type: 'warning',
                html: `<h3>Attenzione!</h3>  La categoria ${this.notaCategoria.toUpperCase()} ha l'importo limitato: ${this.maxImporto} Euro. <br> Sei sicuro di voler procedere con l'importo indicato?`,
                showCancelButton: true,
                cancelButtonText: 'No',
                showConfirmButton: true,
                confirmButtonText: 'Si',
            }).then(resp => {
                if (resp.dismiss === 'cancel')
                    this.importo = +this.notaItem.importo
            })
        }
    },
    modificaNota(importo, isAuto) {
      var $this = this;
      this.$store
        .dispatch("notaSpese/updateNota", {
          idNota: this.notaItem.id,
          importo: importo,
          mese: this.mese,
          idRichiesta: this.idRichiesta,
          ricevutaFile: this.ricevutaFile,
          ricevutaName: this.ricevutaName,
          ricevutaUrl: this.ricevutaUrl,
          isAuto: isAuto,
          isFirmata: this.notaItem.data_firma != null
        })
        .then(function(res) {
          $this.open = false;
        });
    }
  }
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// modules/Home/views/src/components/CambiaNota.vue